<script>
  import {onMount} from "svelte";
  import {LeafletMap, Polygon, Popup, TileLayer, Tooltip} from 'svelte-leafletjs';

  import strok from "./static/strok.json";
  import boliger from "./static/bolig.json";
  import gravlund from "./static/gravlund.json";

  let areaTypes = [
    strok,
//    boliger,
    gravlund
  ];

  const mapOptions = {
    center: [59.9726, 10.7203],
    zoom: 11
  };
  const tileUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
  const tileLayerOptions = {
    minZoom: 0,
    maxZoom: 20,
    maxNativeZoom: 19,
    attribution: "© OpenStreetMap contributors",
  };

  let leafletMap;

  const oslo_south = 59.88097;
  const oslo_north = 59.96945;
  const oslo_west = 10.68206;
  const oslo_east = 10.86548;

  onMount(() => {
    leafletMap.getMap().fitBounds([[oslo_north, oslo_west], [oslo_south, oslo_east]]);
  });

  function onAreaClick(event) {
    leafletMap.getMap().fitBounds(event.detail.sourceTarget._bounds);
  }

</script>

<div class="example" style="width: 100%; height: 100%;">
    <LeafletMap bind:this={leafletMap} options={mapOptions}>
        <TileLayer url={tileUrl} options={tileLayerOptions}/>
	{#each areaTypes as at}
	  {#each at.areas as area}
	    <Polygon latLngs={area.coordinates} color={at.color} fillColor={at.color} events={["click"]} on:click={onAreaClick}>
              <Tooltip>{area.name}</Tooltip>
            </Polygon>
	  {/each}
	{/each}
    </LeafletMap>
</div>

